import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicPlaylist } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getOwnedPlaylists = async (orgId: string): Promise<PublicPlaylist[]> => {
  const response = await axiosClient.get(`${orgId}/playlists/owned`);
  return response.data;
};

export function ownedPlaylistsQueryKey(orgId: string) {
  return ["playlists", orgId, "owned"];
}

export function useOwnedPlaylists(
  orgId: string,
  queryOptions?: Partial<UseQueryOptions<PublicPlaylist[], HttpError>>,
) {
  return useQuery({
    queryKey: ownedPlaylistsQueryKey(orgId),
    queryFn: () => getOwnedPlaylists(orgId),
    ...queryOptions,
  });
}
